import { Component, NgZone } from '@angular/core';
import { AgRendererComponent } from '@ag-grid-community/angular';
import { ICellRendererParams, Logger } from '@ag-grid-community/core';
import { ActivatedRoute, Router } from "@angular/router";
import { AppState } from '../../../../app.state';
import { Store } from '@ngrx/store';
import { selectTankGridChange } from 'src/app/state/selectors/tank-profile.selectors';
import { take } from 'rxjs/internal/operators/take';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'tank-notification-item-renderer',
  templateUrl: "./tank-notification-item-renderer.component.html",
  styleUrls: ["./tank-notification-item-renderer.component.css"],
})


export class TankNotificationItemRendererComponent implements AgRendererComponent {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private ngZone: NgZone,
    public translate: TranslateService,
    private store: Store<AppState>
  ) { }

  tankNotification: any;

  // gets called once before the renderer is used
  agInit(passedParams: ICellRendererParams): void {
    this.parseData(passedParams);
  }

  parseData(passedParams: ICellRendererParams): void {
    this.tankNotification = passedParams.data;
  }

  // gets called whenever the user gets the cell to refresh
  refresh(params: ICellRendererParams) {
    // set value into cell again
    this.parseData(params);
    return true;
  }
}
